import {Button} from '@material-ui/core';
import React from 'react';
import './UserAccountNotFound.sass';

type UserAccountNotFoundProps = {
  onLogout: () => void;
};

const UserAccountNotFound = (props: UserAccountNotFoundProps) => {
  return (
    <div className="user-account-not-found">
      <p>Sorry, you do not appear to have been granted access to this website. Please contact your administrator.</p>
      <Button onClick={props.onLogout} variant="contained" color="primary">
        Return To Login
      </Button>
    </div>
  );
};

export default UserAccountNotFound;
